import { render, staticRenderFns } from "./GroupMoveSelector.vue?vue&type=template&id=22f4eb10&scoped=true"
import script from "./GroupMoveSelector.vue?vue&type=script&lang=js"
export * from "./GroupMoveSelector.vue?vue&type=script&lang=js"
import style0 from "./GroupMoveSelector.vue?vue&type=style&index=0&id=22f4eb10&scoped=true&lang=css"
import style1 from "./GroupMoveSelector.vue?vue&type=style&index=1&id=22f4eb10&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f4eb10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f4eb10')) {
      api.createRecord('22f4eb10', component.options)
    } else {
      api.reload('22f4eb10', component.options)
    }
    module.hot.accept("./GroupMoveSelector.vue?vue&type=template&id=22f4eb10&scoped=true", function () {
      api.rerender('22f4eb10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataAccess/group/GroupMoveSelector.vue"
export default component.exports